module.exports = __webpack_public_path__ + "static/media/header.3bb200b4.png";